import Active from "@/views/active/index.vue";
import Active828 from "@/views/active/active828.vue";
export default [
  {
    path: "/active11/:id",
    name: "Active",
    meta: {
      hideTab: true,
    },
    component: Active,
  },
  {
    path: "/active828",
    name: "Active828",
    meta: {
      hideTab: true,
    },
    component: Active828,
  },
];
